import { render, staticRenderFns } from "./Estudios.vue?vue&type=template&id=56aaeda3&scoped=true&"
import script from "./Estudios.vue?vue&type=script&lang=js&"
export * from "./Estudios.vue?vue&type=script&lang=js&"
import style0 from "./Estudios.vue?vue&type=style&index=0&id=56aaeda3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aaeda3",
  null
  
)

export default component.exports